import React from 'react';
import '../less/main.less';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.less';
import { ReactSVG } from 'react-svg';
import proposal_arrow from '../img/proposal_arrow.svg';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { children, tabs, tab, toggle, title, id, page, showArrows, subtitle } = this.props;

  const showControls = showArrows && !(this.state.proposalAtStart && this.state.proposalAtEnd);

  const btns = tabs.map((item, index) => {
    const isSelected = tab === item.tab ? ' selected' : '';
    const isHidden = item.hidden ? ' hidden' : '';

    const btn = (
      <div
        id={`${page ? page : ''} ${item.tab}-tab`}
        className={`item-tabs-new__btn${isSelected}`}
        onClick={() => this.toggleTab(item.tab)}
        onKeyDown={(e) => e.key === 'Enter' && this.toggleTab(item.tab)}
        tabIndex="0"
        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.title))}}
      />
    );

    return (
      <SwiperSlide
        key={index}
        className={`tabs-new__item item-tabs-new${isHidden}`}
      >
        {btn}
      </SwiperSlide>
    );
  });

  const childrenArray = React.Children.toArray(children);

  const renderedChildren = tabs.map((tabItem, index) => {
    const content = childrenArray[index];
    const tabValue = tabItem.tab;

    return (
      <div
        key={tabValue}
        className={`tabs-new__content${tab === tabValue ? ' active' : ''}`}
      >
        {content}
      </div>
    );
  });

  return (
    <div className="tabs-new" id={id}>
      {(title || showControls) && (
        <div className={`tabs-new__top top-tabs-new${!title ? ' top-tabs-new_no-title' : ''}`}>
          <div className="container">
            <div className="top-tabs-new__row">
              {(title || subtitle) && (
                <div className="top-tabs-new__left">
                  {title && <h2 className="top-tabs-new__title">{this.l10n(title)}</h2>}
                  {subtitle && <p className="top-tabs-new__subtitle">{this.l10n(subtitle)}</p>}
                </div>
              )}
              {showControls && (
                <div className="top-tabs-new__controls">
                  <button
                    onClick={this.slidePrev}
                    disabled={this.state.proposalAtStart}
                    className={`top-tabs-new__btn top-tabs-new__btn_left ${
                      this.state.proposalAtStart ? 'top-tabs-new__btn_disabled' : ''
                    }`}
                  >
                    <ReactSVG
                      src={proposal_arrow}
                      className="top-tabs-new__arrow top-tabs-new__arrow_left"
                    />
                  </button>
                  <button
                    onClick={this.slideNext}
                    disabled={this.state.proposalAtEnd}
                    className={`top-tabs-new__btn top-tabs-new__btn_right ${
                      this.state.proposalAtEnd ? 'top-tabs-new__btn_disabled' : ''
                    }`}
                  >
                    <ReactSVG
                      src={proposal_arrow}
                      className="top-tabs-new__arrow top-tabs-new__arrow_right"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="tabs-new__body">
        <Swiper
          ref={this.swiperRef}
          slidesPerView="auto"
          autoHeight={false}
          onSwiper={swiper => this.initSlider(swiper)}
          threshold={10}
          observer={true}
          observeParents={true}
        >
          {btns}
        </Swiper>
      </div>
      {renderedChildren}
    </div>
  );
}
